import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { Pair } from "../../obj/Pair";
import { SellerContract } from "../../entity/SellerContract";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { ValidationService } from "../../service/validation.service";
import { User } from "../../entity/User";
import { Company } from "../../entity/Company";
import { MatDialog } from "@angular/material/dialog";
import { Account } from "src/app/entity/Account";
import { Utility } from "src/app/entity/Utility";
import { State } from "../../entity/State";
import { AlertType } from "../../entity/AlertType";
import { AlertTypeOption } from "../../entity/AlertTypeOption";
import { AlertSubscription } from "../../entity/AlertSubscription";
import { HeaderComponent } from "../incs/header.component";
import { NgClass } from "@angular/common";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { NgxMaskDirective } from "ngx-mask";


@Component({
    selector: "kilowant-seller-account",
    templateUrl: "../../../html/seller/main-seller-account.html",
    imports: [HeaderComponent, FormsModule, ReactiveFormsModule, NgClass, NgMultiSelectDropDownModule, MatTabGroup, MatTab, NgxMaskDirective]
})
export class SellerAccountComponent extends AbstractSellerComponent {
    sellerContracts: SellerContract[] = [];
    step: number = 1;
    old_password: string = "";
    password: string = "";
    password2: string = "";
    alertsData: Pair[] = [];
    selectedAlerts: AlertSubscription[] = [];
    viewAlertsCategory: boolean[] = [];
    hideSecondStep: boolean = false;
    public sellerUserDetailsForm: FormGroup;
    currentPhoneNumber: FormControl = new FormControl("");
    otherTextInput = false;
    dropdownList: any = [];
    selectedItems: any = [];
    dropdownSettings: any = {};
    hideThirdStep = false;
    hideFirstStep = true;
    accounts: Account[] = [];
    utility: Utility = null!;
    utilities: Utility[] = [];
    allUtilities: Utility[] = null!;
    sellerList: Company[] = [];
    newCompanyDetails: Company = new Company();
    userDetails: any;
    company: any;
    existingCompanyId: any;
    firstVal: any;
    submitted = false;
    newSite: any = [];
    newValue: any = [];
    btnDisable: boolean = true;
    states: any;
    showOnboardingAcc: boolean = true;
    error: string = "";
    errors: string[] = [];
    constructor(
        private _fb: FormBuilder,
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog,
        public validationService: ValidationService
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
        if (this.router.url == "/seller/my-account") {
            this.showOnboardingAcc = false;
        } else {
            this.showOnboardingAcc = true;
        }
        this.sellerUserDetailsForm = this._fb.group({
            firstName: [""],
            lastName: [""],
            email: [""],
            phone: [""],
            usercompanyname: [""],
            companyList: [""],
            newCompanyname: ["", Validators.required],
            address1: [""],
            address2: [""],
            marketType: [""],
            website: [""],
            postalCode: [""],
            city: [""],
            state: [""],
            phoneNumber: [""],
            yourCompanyName: [""],
            utility: [""]
        });
        this.generalService.getDetails()
            .then(u => {
                this.user = u;
                if (this.user == null) {
                    this.router.navigate(["/user/login"], { queryParams: { redirect: this.router.url } });
                } else {
                    this.setValue();
                }

                this.generalService.getUtilities(null!).then(utilities => this.utilities = utilities);

                this.generalService.getAlerts().then((alertsData: any) => {
                    this.alertsData = alertsData;
                    for (var i = 0; i < this.alertsData.length; i++) {
                        this.viewAlertsCategory.push(false);
                    }
                });
                this.generalService.getSelectedAlerts().then((selectedAlerts: any) => {
                    this.selectedAlerts = selectedAlerts;
                });
            });
        this.getSellerList();
        this.dropdownSettings = {
            singleSelection: false,
            idField: "id",
            textField: "name",
            itemsShowLimit: 9,
            allowSearchFilter: false,
            closeDropDownOnSelection: false,
        };
        this.generalService.getStates(false).then((state: any) => {
            this.states = state;
        });
    }

    setValue() {
        this.sellerUserDetailsForm.controls.firstName.setValue(this.user.firstName);
        this.sellerUserDetailsForm.controls.lastName.setValue(this.user.lastName);
        this.sellerUserDetailsForm.controls.email.setValue(this.user.email);
        this.sellerUserDetailsForm.controls.phone.setValue(this.user.phone);
        this.sellerUserDetailsForm.controls.email.disable();
        this.currentPhoneNumber.setValue(this.user.phone);
    }

    getSellerList() {
        this.generalService.getSellersListForAssociation().then((data: any) => this.sellerList = data);
    }

    addRemoveAlert(alertType: AlertType, alertOptions: AlertTypeOption[]): void {
        var pos = this.positionInSelected(alertType);
        if (pos > 0) {
            this.selectedAlerts.splice(pos, 1);
        } else {
            var subscription = new AlertSubscription();
            subscription.alertType = alertType;
            if (alertOptions != null && alertOptions.length > 0) {
                subscription.alertOption = alertOptions[0];
            }
            this.selectedAlerts.push(subscription);
        }
    }

    positionInSelected(alertType: AlertType): number {
        for (var i = 0; i < this.selectedAlerts.length; i++) {
            if (this.selectedAlerts[i] != null && this.selectedAlerts[i].alertType != null && this.selectedAlerts[i]!.alertType!.id == alertType.id) {
                return i;
            }
        }
        return -1;
    }

    setAlerts(): void {
        this.generalService.setSelectedAlerts(this.selectedAlerts).subscribe(
            (res: any) => {
            },
            (err) => {
                if (err.status == 400) {
                    this.setErrorText(err.error);
                }
            }
        );
    }

    get f() {
        return this.sellerUserDetailsForm.controls;
    }

    addUser(ifNextStep: boolean) {
        if (ifNextStep) {
            this.step = 2;
            this.hideThirdStep = false;
            this.hideSecondStep = true;
            this.hideFirstStep = false;
        }
    }

    addCompany(ifNextStep: boolean) {
        if (this.sellerUserDetailsForm.value.companyList == "other") {
            this.submitted = true;
            if (this.sellerUserDetailsForm.invalid) {
                return;
            }
        }
        if (ifNextStep) {
            this.step = 3;
            this.hideThirdStep = true;
            this.hideSecondStep = false;
            this.hideFirstStep = false;
            this.existingCompanyId = this.sellerUserDetailsForm.value.companyList;
            if (this.sellerUserDetailsForm.value.companyList == "other") {
                this.sellerUserDetailsForm.controls.yourCompanyName.setValue(this.sellerUserDetailsForm.value.newCompanyname);
            } else {
                console.log(this.existingCompanyId);
                if (this.existingCompanyId == undefined || this.existingCompanyId == null) {
                    if (this.user.company != null) {
                        this.firstVal = this.user.company.name;
                        this.sellerUserDetailsForm.controls.yourCompanyName.setValue(this.firstVal);
                    }
                } else {
                    var a = this.sellerList.filter((cname: any) =>
                        cname.id == this.existingCompanyId)
                    this.sellerUserDetailsForm.controls.yourCompanyName.setValue(a[0].name);
                }
            }
        }
    }
    goToBackStep2(ifNextStep: boolean) {
        if (!ifNextStep) {
            this.step = 2;
            this.hideThirdStep = false;
            this.hideSecondStep = true;
            this.hideFirstStep = false;
        }
    }
    goToBackStep(ifNextStep: boolean) {
        if (!ifNextStep) {
            this.step = 1;
            this.hideThirdStep = false;
            this.hideSecondStep = false;
            this.hideFirstStep = true;
        }
    }
    submitSellerForm() {
        if (this.sellerUserDetailsForm.value.companyList == "other") {
            this.newCompanyDetails = {
                id: 1,
                name: this.sellerUserDetailsForm.value.newCompanyname,
                active: false,
                isSupplier: true,
                marketType: null!,
                website: this.sellerUserDetailsForm.value.website,
                utilities: null!,
                autoTransactionsOn: true,
                taxExempt: false,
                federalTaxID: null!,
                taxExemptCertificateDocument: null!,
                state: new State(this.sellerUserDetailsForm.value.state),
                city: this.sellerUserDetailsForm.value.city,
                addressLine1: this.sellerUserDetailsForm.value.address1,
                addressLine2: this.sellerUserDetailsForm.value.address2,
                zip: this.sellerUserDetailsForm.value.postalCode,
                phone: this.sellerUserDetailsForm.value.phoneNumber,
                logo: null,
                enrollEmail: null,
                enrollCCEmail: null
            }
            this.user = Object.assign(new User(), {
                id: 1,
                isActive: true,
                firstName: this.sellerUserDetailsForm.value.firstName,
                lastName: this.sellerUserDetailsForm.value.lastName,
                isResidential: false,
                jobTitle: "",
                email: this.sellerUserDetailsForm.value.email,
                phone: this.sellerUserDetailsForm.value.phone,
                totalLogins: 0,
                company: this.newCompanyDetails,
                autoTransactionsOn: false,
                isSupplier: true,
                isAdvisor: false,
                lastLogin: null!,
                state: null,
                city: null,
                addressLine1: null,
                addressLine2: null,
                zip: null,
                kilowantUViewed: true,
                firstAccountSetupFinished: true,
                utilities: this.sellerUserDetailsForm.value.utility,
            });
            this.generalService.updateUser(this.user, 0, null, false, false).subscribe((data: any) => {
                this.reloadUser().then(u => {
                    this.router.navigate(["seller/home"]);
                });
            });
        } else {
            this.user = Object.assign(new User(), {
                id: 1,
                isActive: true,
                firstName: this.sellerUserDetailsForm.value.firstName,
                lastName: this.sellerUserDetailsForm.value.lastName,
                isResidential: false,
                jobTitle: "",
                email: this.sellerUserDetailsForm.value.email,
                phone: this.sellerUserDetailsForm.value.phone,
                totalLogins: 0,
                company: this.newCompanyDetails,
                autoTransactionsOn: false,
                isSupplier: true,
                isAdvisor: false,
                lastLogin: null!,
                state: null,
                city: null,
                addressLine1: null,
                addressLine2: null,
                zip: null,
                kilowantUViewed: true,
                firstAccountSetupFinished: true,
                utilities: this.sellerUserDetailsForm.value.utility,
            });
            this.generalService.addExistingCompany(this.existingCompanyId).subscribe((data: any) => {
                this.generalService.updateUser(this.user, 0, null, false, false).subscribe((data: any) => {
                    this.reloadUser().then(x => {
                        this.router.navigate(["seller/home"]);
                    });
                });
            });
        }
    }

    updateProfile(): void {
        this.clearErrors();
        if (this.user.firstName == null || this.user.firstName.length == 0) {
            this.addError("FirstName");
        }
        if (this.user.lastName == null || this.user.lastName.length == 0) {
            this.addError("LastName");
        }
        if (this.currentPhoneNumber.value == null || this.currentPhoneNumber.value.length == 0) {
            this.addError("Phone");
        }

        if (this.errorY().showError()) {
            this.setErrorText("Please enter the data requested above.");
            return;
        }

        if (!this.currentPhoneNumber.valid) {
            this.addError("Phone");
            this.setErrorText("Phone number is not correct.");
            return;
        }
        this.user.phone = this.currentPhoneNumber.value;


        this.generalService.updateUser(this.user, 0, null, false, false).subscribe((data: any) => {
            this.reloadUser();
        });
    }

    sendUpdatePasswordForm(): void {
        this.clearErrors();
        if (this.old_password == null || this.old_password.length == 0) {
            this.addError("OldPassword");
        }
        if (this.password == null || this.password.length == 0) {
            this.addError("Password");
        }
        if (this.password2 == null || this.password2.length == 0) {
            this.addError("Password2");
        }
        if (this.errorY().showError()) {
            this.setErrorText("Please enter the data requested above in order to update your password.");
            return;
        }

        if (!this.validationService.validate("User", "password", this.password, this.errorY, "Password")) {
            return;
        }
        if (this.password != this.password2) {
            this.addError("Password2");
            this.setErrorText("Passwords do not match.");
            return;
        }
        this.generalService.updateUserPassword(this.old_password, this.password)
            .subscribe((res: any) => {
            },
                err => {
                    if (err.status == 400) {
                        this.setErrorText(err.error);
                    }
                });
    }

    getCompanyName(event: any): void {
        if (event.target.value == "other") {
            this.otherTextInput = true;
        } else {
            this.otherTextInput = false;
        }
    }

    getState(event: any) {

    }
}